import Immutable from 'immutable';
import { defaultCommunicationObject, updateCommunicationObject } from '~client/reducers/shared';
import { longtailBookingsActionTypes } from '~constants/actionTypes';

export const defaultState = Immutable.fromJS({
  listings: {
    communication: defaultCommunicationObject,
    payload: [],
    totalCount: 0,
    totalPages: 1,
  },
});

const bookingsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case longtailBookingsActionTypes.SET_LONG_TAIL_BOOKINGS: {
      const nextState = state.deleteIn(['listings', 'payload']);
      return nextState.mergeDeep({
        listings: {
          payload: action.payload.viewer ? action.payload.viewer.company.orders.edges : [],
          totalCount: action.payload.viewer.company.orders.totalCount,
          totalPages: action.payload.viewer.company.orders.pageInfo.numPages,
        },
      });
    }

    case longtailBookingsActionTypes.GET_LONG_TAIL_BOOKINGS_CS:
      return state.mergeDeep({
        listings: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    default:
      return state;
  }
};

export default bookingsReducer;
